// extracted by mini-css-extract-plugin
export default {"boardContainer":"board_boardContainer__Mqmcn"};